import store from '@state/store'
import { env } from '@/env'
const CryptoJS = require('crypto-js')

export default [
  // Redirection Domain Url for Authentication

  {
    path: '/',
    redirect: 'authentication',
  },

  // Redirection of User as per Role

  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/login')),
  },

  // OAuth authentication URL

  {
    path: '/authentication',
    name: 'authentication',
    component: () => lazyLoadView(import('@src/oidcComponents/authentication')),
  },

  // Url to Preview landing Page (for SandOAdmin)

  {
    path: '/servicepreview',
    name: 'servicepreview',
    component: () => lazyLoadView(import('@layouts/adminLandingpage')),
  },

  // Handling Routing Url for Sando Admin Role

  {
    path: '/superAdmin',
    component: () => lazyLoadView(import('@router/layouts/superAdmin')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        let RoleInformationObject = toResolveUserRole()
        if (RoleInformationObject.RoleName === 'Admin') {
          localStorage.setItem('roleId', 11)
          next()
        } else if (RoleInformationObject.RoleName === 'None') {
          // Continue to the authentication page
          // next({ name: 'authentication' })
          next({ name: routeTo.name, query: routeTo.query })
        } else {
          next({ name: 'authentication' })
        }
      },
    },

    children: [
      {
        path: '',
        redirect: 'authentication',
      },
      {
        path: 'manageVendor',
        name: 'manage-vendor',
        component: () => lazyLoadView(import('@views/superAdmin/manageVendor')),
      },
      {
        path: 'createVendor',
        name: 'create-new-vendor',
        component: () => lazyLoadView(import('@views/superAdmin/createVendor')),
      },
      {
        path: 'editVendor',
        name: 'edit-vendor',
        component: () => lazyLoadView(import('@views/superAdmin/createVendor')),
      },
      {
        path: 'vendor-user-list',
        name: 'vendor-user-list',
        component: () =>
          lazyLoadView(import('@views/superAdmin/vendorUserList')),
      },
      {
        path: 'vendorServices',
        name: 'vendor-service',
        component: () =>
          lazyLoadView(import('@views/superAdmin/vendorServices')),
      },
      {
        path: 'createService',
        name: 'create-vendor-service',
        component: () =>
          lazyLoadView(import('@views/superAdmin/createServiceForm')),
      },
      {
        path: 'editServiceForm',
        name: 'edit-vendor-service',
        component: () =>
          lazyLoadView(import('@views/superAdmin/createServiceForm')),
      },
      {
        path: 'sequenceOrderServiceForm',
        name: 'sequenceOrderServiceForm',
        component: () =>
          lazyLoadView(import('@views/superAdmin/sequenceOrderServiceForm')),
      },
      {
        path: 'manageBuildings',
        name: 'manageBuildings',
        component: () =>
          lazyLoadView(import('@views/superAdmin/manageBuildings')),
      },
      {
        path: 'manageDistribution',
        name: 'manage-distribution',
        component: () =>
          lazyLoadView(import('@views/superAdmin/manageDistribution')),
      },
      {
        path: 'manageServiceform',
        name: 'manageServiceform',
        component: () =>
          lazyLoadView(import('@views/superAdmin/manageServiceform')),
      },
      {
        path: 'allRefundsTransactionList',
        name: 'allRefundsTransactionList',
        component: () =>
          lazyLoadView(import('@views/superAdmin/refundsGridTransaction')),
      },
      {
        path: 'inquiry',
        name: 'inquiry',
        meta: {
          authRequired: false,
        },
        component: () => lazyLoadView(import('@views/superAdmin/enquiry')),
      },
      {
        path: 'reporting',
        name: 'reporting',
        component: () =>
          lazyLoadView(import('@views/superAdmin/reportList.vue')),
      },
      {
        path: 'reportAnalysis',
        name: 'reportAnalysis',
        component: () =>
          lazyLoadView(import('@views/superAdmin/reportAnalysis.vue')),
      },
      {
        path: 'setting',
        name: 'paymentsetting',
        component: () =>
          lazyLoadView(import('@views/superAdmin/paymentsetting.vue')),
      },
      {
        path: 'adminorder',
        name: 'adminorder',
        meta: {
          authRequired: false,
        },
        component: () => lazyLoadView(import('@src/payment/order/adminorder')),
      },
      {
        path: 'viewmilestone',
        name: 'adminviewmilestone',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(import('@src/payment/order/viewAdminMilestone')),
      },
      {
        path: 'adminpayout',
        name: 'adminpayout',
        meta: {
          authRequired: false,
        },
        component: () => lazyLoadView(import('@src/payment/order/payout')),
      },
      {
        path: 'payout-history',
        name: 'payout-history',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(import('@src/payment/order/payoutHistory')),
      },
    ],
  },

  // Handling Routing Url for Resident Role

  {
    path: '/resident',
    component: () => lazyLoadView(import('@router/layouts/resident')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        let RoleInformationObject = toResolveUserRole()
        console.log(' RoleInformationObject', RoleInformationObject)
        if (RoleInformationObject.RoleName === 'Resident') {
          localStorage.setItem('roleId', 15)
          localStorage.setItem(
            'subId',
            RoleInformationObject.userInformation.sub
              ? RoleInformationObject.userInformation.sub
              : 11111
          )
          next()
        } else if (RoleInformationObject.RoleName === 'None') {
          // Continue to the authentication page
          // next({ name: 'authentication' })
          next({ name: routeTo.name, query: routeTo.query })
        } else {
          next({ name: 'authentication' })
        }
      },
    },
    children: [
      {
        path: 'buildingLinkServices',
        name: 'landingPage',
        component: () => lazyLoadView(import('@layouts/landingPage')),
      },
      {
        path: 'InquiriesHistory',
        name: 'InquiriesHistory',
        component: () =>
          lazyLoadView(import('@views/resident/pastResidentHistoryInquiry')),
      },
      {
        path: 'residentorder',
        name: 'residentorder',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(import('@src/payment/order/residentorder')),
      },
      {
        path: 'viewmilestone',
        name: 'residentviewmilestone',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(import('@src/payment/order/viewResidentMilestone')),
      },
    ],
  },

  // Handling Routing Url for Vendor Role

  {
    path: '/vendor',
    component: () => lazyLoadView(import('@router/layouts/provider')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        let RoleInformationObject = toResolveUserRole()
        if (RoleInformationObject.RoleName === 'Vendor') {
          localStorage.setItem('roleId', 18)
          localStorage.setItem(
            'bussinesId',
            RoleInformationObject.userInformation.business_id
          )
          next()
        } else if (RoleInformationObject.RoleName === 'None') {
          // Continue to the authentication page
          // next({ name: 'authentication' })
          next({ name: routeTo.name, query: routeTo.query })
        } else {
          next({ name: 'authentication' })
        }
      },
    },
    children: [
      {
        path: 'vendorServicesForms',
        name: 'vendorServicesForms',
        component: () =>
          lazyLoadView(import('@views/vendor/vendorServicesForms')),
      },
      {
        path: 'vendorCreateServiceForm',
        name: 'vendorCreateServiceForm',
        component: () =>
          lazyLoadView(import('@views/vendor/vendorCreateServiceForm')),
      },
      {
        path: 'vendorinquiry',
        name: 'vendorinquiry',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(import('@views/vendor/requestedInquiries')),
      },
      {
        path: 'vendororder',
        name: 'vendororder',
        meta: {
          authRequired: false,
        },
        component: () => lazyLoadView(import('@src/payment/order/vendororder')),
      },
      {
        path: 'vendorReport',
        name: 'vendorReport',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(
            import('@src/router/views/provider/vendorReconciliationReport')
          ),
      },
      {
        path: 'viewmilestone',
        name: 'viewmilestone',
        meta: {
          authRequired: false,
        },
        component: () =>
          lazyLoadView(import('@src/payment/order/viewVendorMilestone')),
      },
    ],
  },

  // Routes to handle the  User Authentication and OAuth Log-In
  {
    path: '/unauthorized', // Needs to match redirectUri in you oidcSettings
    name: 'unauthorized',
    component: () => lazyLoadView(import('@src/oidcComponents/unauthorized')),
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/oidc-callback', // Needs to match redirectUri in you oidcSettings
    name: 'oidcCallback',
    component: () => lazyLoadView(import('@src/oidcComponents/OidcCallback')),
  },
  {
    path: '/oidc-popup-callback', // Needs to match popupRedirectUri in you oidcSettings
    name: 'oidcPopupCallback',
    component: () =>
      lazyLoadView(import('@src/oidcComponents/OidcPopupCallback')),
  },
  {
    path: '/oidc-callback-error', // Needs to match redirect_uri in you oidcSettings
    name: 'oidcCallbackError',
    component: () =>
      lazyLoadView(import('@src/oidcComponents/OidcCallbackError')),
    meta: {
      isPublic: true,
    },
  },
  {
    path: '/signin-oidc-error', // Needs to match redirect_uri in you oidcSettings
    name: 'signin-oidc-error',
    component: () => lazyLoadView(import('@src/oidcComponents/errorInAuth')),
    meta: {
      isPublic: true,
    },
  },

  {
    path: '/new-user', // Needs to match redirect_uri in you oidcSettings
    name: 'new-user',
    component: () => lazyLoadView(import('@src/user/newUserForm')),
    meta: {
      isPublic: true,
    },
  },

  // OpendId OAuth Testing Components For Referrence

  // {
  //   path: '/protected',
  //   name: 'protected',
  //   component: () => lazyLoadView(import('@src/oidcComponents/Protected')),
  // },
  // {
  //   path: '/app',
  //   name: 'app',
  //   component: () => lazyLoadView(import('@src/oidcComponents/oidcApp')),
  //   meta: {
  //     isPublic: true,
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'home',
  //       component: () => lazyLoadView(import('@src/oidcComponents/home')),
  //       meta: {
  //         isPublic: true,
  //       },
  //     },
  //   ],
  // },

  {
    path: '/404',
    name: '404',
    component: require('@views/_404').default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
    meta: {
      isPublic: true,
    },
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
]

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    // loading: require('@views/_loading').default,
    loading: require('@views/loader').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 400,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 100000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}

function getUserInfoToken() {
  let secretKey = env.VUE_APP_SECRET_KEY
  if (!window.localStorage.getItem('auth.authToken')) {
    return false
  }
  try {
    const bytes = CryptoJS.AES.decrypt(
      window.localStorage.getItem('auth.authToken')
        ? window.localStorage.getItem('auth.authToken').toString()
        : '',
      secretKey
    )
    const serializedState = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))

    if (serializedState === null) {
      return false
    } else {
      return serializedState
    }
  } catch (error) {
    return false
  }
}
function toResolveUserRole() {
  let userInformation = getUserInfoToken()

  let Role = userInformation
    ? userInformation.user_type_id.substring(0, 2)
    : '00'
  var RoleInformationObject = {
    RoleName: 'None',
    userInformation: userInformation,
  }
  if (!userInformation) {
    return RoleInformationObject
  }
  if (Role === '14' || Role === '11') {
    RoleInformationObject.RoleName = 'Admin'
  } else if (Role === '18') {
    RoleInformationObject.RoleName = 'Vendor'
  } else {
    RoleInformationObject.RoleName = 'Resident'
  }
  return RoleInformationObject
}
